import React, { useEffect, useState } from "react";
import { getDisplayRecords } from "./approverKpi";
import ApproverTable from "../../components/Table/ApproverTable";
import NavButtons from "../../components/NevBar/NavButtons";
import Header from "../../components/Header/Header";
import WaterMark from "../../components/WaterMark";

const ApproverIndex = () => {
  const [records, setRecords] = useState(null);
  const [loading, setLoading] = useState(false)

  const displayRecords = async () => {
    try {
      const response = await getDisplayRecords();
      const data = response;
      setRecords(data);
    } catch (error) {
      console.error("Error fetching records:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    displayRecords();
  }, []);


  return <div className="overflow-x-auto justify-center items-center w-[400px] md:w-full ">
    <WaterMark />
    <Header />
    <ApproverTable data={records} />
    {/* <NavButtons /> */}

  </div>;

};

export default ApproverIndex;
